module.exports = __webpack_public_path__ + "img/mastry_guidline.0d8b9f24.png";